import { NavBarController } from "./navbar";
import { NavbarRegistrationServiceImplementation } from "./navbar-registration-service";
import { Prerequisite, PrerequisiteLoadingService, PrerequisiteContext } from "../loading/prerequisite-loading-service";
import app from "../../sdAppModule";
import { SdPresenceStatesCollection } from "./presence";

app
  .service("navbarRegistrationService", NavbarRegistrationServiceImplementation)
  .service("sdPresenceStatesCollection", SdPresenceStatesCollection)
  .controller("navBarCtrl", NavBarController)
  .run(
    (
      prerequisiteLoadingService: PrerequisiteLoadingService,
      navbarRegistrationService: NavbarRegistrationServiceImplementation
    ) => {
      prerequisiteLoadingService.registerCallbackForPrerequisite(
        "navbarRegistrationService",
        (unused: Prerequisite, context: PrerequisiteContext) => {
          return navbarRegistrationService.loadPrerequisites(context);
        },
        false
      );
    }
  );
